import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ConfigService } from '../services/config.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class PrivateGuard  {
  constructor(
    private authService: AuthService,
    private configService: ConfigService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.configService.initError || this.authService.isAuthenticated() || !this.configService.get().privateMode) {
      return true;
    }

    if (this.configService.get().ssoType === 'EZPROXY' && sessionStorage.getItem('isLoggingIn')) {
      return true;
    }

    const queryParams = {};

    if (route.queryParams.internalLogin) {
      queryParams['internalLogin'] = route.queryParams.internalLogin;
    }
    if (route.queryParams.chpwd) {
      queryParams['chpwd'] = route.queryParams.chpwd;
    } else if (route.queryParams.v) {
      queryParams['v'] = route.queryParams.v;
    } else {
      queryParams['afterLogin'] = !state.url.includes('logout') ? state.url : '/';
    }

    this.router.navigate(['/blank'], { queryParams });
    return false;
  }
}
